import { getNameAndAccountID, getAccountNumber } from '../getNameAndAccountNumber';
import { getServiceId } from '../getServiceID';
import { updateDataToEirAppDB } from '../redesign-5.2/biometrics/biometrics.util';
import { setCookie, setTokenInCookies, triggerAdobeApi } from '../redesign-5.2/redesign.api';
import { getAccountType, getFeature, getLoginOperation, resetPassword } from './loginOperation.api';

export const handleSubmitLoginOperation = async ({
    graphql,
    enteredName,
    userPassword,
    recaptchaV3Token,
    setWaitingApiResponse,
    handleUserVal,
    setInvalidError,
    invalidError,
    toggleRegister,
    setOpenError,
    openError,
    technicalError,
    setTechnicalError,
    setLoginScreen,
    setInvalidText,
    recaptchaRef,
    captchaV2,
    setCaptchaV2Error,
    captchaV2Error,
    userCredential,
    setOtpUuid,
    setLoginOperationValue,
    setIsLoading,
    setOptPopup,
    optPopup,
    setIsPrepay,
}) => {
    try {
        setIsLoading(true);
        setWaitingApiResponse(true);
        handleUserVal(enteredName);

        const loginOperation = await getLoginOperation({
            graphql,
            email: enteredName,
            password: userPassword,
            recaptcha: captchaV2 ? captchaV2 : recaptchaV3Token,
            recaptchaVersion: captchaV2 ? 'V2' : 'V3',
            deviceId:
                userCredential && userCredential.user === enteredName && userCredential.deviceId
                    ? userCredential.deviceId
                    : '',
        });
        setLoginOperationValue(loginOperation);
        sessionStorage.setItem('MFA_FORCED', loginOperation?.data?.login?.mfaForced);
        sessionStorage.setItem(
            'Biometrics_opted_in',
            loginOperation?.data?.login?.biometricOptedIn
        );
        if (
            userCredential &&
            userCredential?.user != undefined &&
            userCredential?.user != enteredName &&
            userCredential?.deviceId != ''
        ) {
            console.log('Different account logged in.....');
            sessionStorage.setItem('TEMP_OFFLINE_TOKEN', loginOperation.data.login.offlineToken);
            sessionStorage.setItem('TEMP_USER', enteredName);
        } else {
            if (
                loginOperation.data.login.mfaForced &&
                loginOperation.data.login.offlineToken != undefined
            ) {
                updateDataToEirAppDB({
                    offlineToken: loginOperation.data.login.offlineToken,
                    user: enteredName,
                });
            }
        }
        if (
            loginOperation.data.login.accessToken != undefined ||
            loginOperation.data.login.refreshToken != undefined
        ) {
            const token = loginOperation.data.login.accessToken;

            setTokenInCookies(token, new Date().getTime() + 60 * 60 * 1000);
            setOtpUuid(loginOperation.data.login.otpUuid);

            if (loginOperation.data.login.mfaToken != undefined) {
                // Device is trusted
                if (token.startsWith('ey')) {
                    setCookie('MFA', 'TOKEN', loginOperation.data.login.mfaToken);

                    const type = await getAccountType({ graphql });
                    const featureList = await getFeature({ graphql, username: enteredName });
                    await setSessionStorageValues({
                        enteredName,
                        loginOperation,
                        featureList,
                    });
                    if (type.accountType.prepay && type.accountType.postpay) {
                        setIsLoading(false);
                        setLoginScreen(1);
                        setWaitingApiResponse(false);
                    } else if (type.accountType.prepay && !type.accountType.postpay) {
                        sessionStorage.setItem('LoggedinUserBillType', 'Prepay');
                        setIsLoading(false);
                        setWaitingApiResponse(false);
                        setIsPrepay(true);
                        window.location.href = `/prepay/dashboard`;
                    } else if (type.accountType.postpay && !type.accountType.prepay) {
                        sessionStorage.setItem('LoggedinUserBillType', 'Bill');

                        console.log('call analytcs......');
                        const response2 = await getNameAndAccountID(graphql);
                        const serviceResponse = await getServiceId(graphql);
                        setWaitingApiResponse(false);
                        setIsPrepay(false);
                        await triggerAdobeApi({ graphql, name: 'login' });

                        // Biometrics capability check
                        let iOSstandaloneMode = window.navigator.standalone;
                        let androidPwaMode = window.matchMedia('(display-mode:standalone)').matches;

                        if ((iOSstandaloneMode || androidPwaMode) && window.PublicKeyCredential) {
                            console.log('biometrics allowed');
                            if (loginOperation.data.login?.biometricOptedIn == null) {
                                setIsLoading(false);
                                setOptPopup(!optPopup);
                                // window.location.href = `/account/dashboard`;
                            } else {
                                setIsLoading(false);
                                window.location.href = `/account/dashboard`;
                            }
                        } else {
                            setIsLoading(false);
                            window.location.href = `/account/dashboard`;
                        }
                    }
                } else if (token.startsWith('AQI')) {
                    // window.location.href = '/bundles/login?email=' + enteredName;
                    setIsLoading(false);
                    const baseUrl = '/bundles/login?email=' + enteredName;
                    const isIonValue = loginOperation.data.login.isION;
                    const token = loginOperation.data?.login?.accessToken;

                    const contextVal = {
                        isIon: isIonValue,
                        token: token,
                        isNoticeClicked: false,
                    };

                    const context = encodeURIComponent(JSON.stringify(contextVal));
                    window.location.href = `${baseUrl}&context=${context}`;
                }
                setIsLoading(false);
                sessionStorage.setItem('loginSuccess', true);
            } else if (loginOperation.data.login.mfaToken == undefined) {
                if (loginOperation.data.login.mfaForced == true) {
                    if (token.startsWith('ey')) {
                        if (loginOperation.data.login.contactFound === true) {
                            setIsLoading(false);
                            setLoginScreen(3);
                        } else {
                            setIsLoading(false);
                            setLoginScreen(2);
                        }
                    } else if (token.startsWith('AQI')) {
                        // window.location.href = '/bundles/login?email=' + enteredName;
                        setIsLoading(false);
                        const baseUrl = '/bundles/login?email=' + enteredName;
                        const isIonValue = loginOperation.data.login.isION;
                        const token = loginOperation.data?.login?.accessToken;

                        const contextVal = {
                            isIon: isIonValue,
                            token: token,
                            isNoticeClicked: false,
                        };

                        const context = encodeURIComponent(JSON.stringify(contextVal));
                        window.location.href = `${baseUrl}&context=${context}`;
                    }
                    setIsLoading(false);
                    sessionStorage.setItem('loginSuccess', true);
                } else if (loginOperation.data.login.mfaForced == false) {
                    if (token.startsWith('ey')) {
                        const featureList = await getFeature({
                            graphql,
                            username: enteredName,
                        });
                        const type = await getAccountType({ graphql });
                        await setSessionStorageValues({
                            enteredName,
                            loginOperation,
                            featureList,
                        });
                        if (type.accountType.prepay && type.accountType.postpay) {
                            setIsLoading(false);
                            setLoginScreen(1);
                            setWaitingApiResponse(false);
                        } else if (type.accountType.prepay && !type.accountType.postpay) {
                            sessionStorage.setItem('LoggedinUserBillType', 'Prepay');
                            setIsLoading(false);
                            setWaitingApiResponse(false);
                            window.location.href = `/prepay/dashboard`;
                        } else if (type.accountType.postpay && !type.accountType.prepay) {
                            sessionStorage.setItem('LoggedinUserBillType', 'Bill');

                            console.log('call analytcs......');
                            const response2 = await getNameAndAccountID(graphql);
                            const serviceResponse = await getServiceId(graphql);
                            setWaitingApiResponse(false);
                            await triggerAdobeApi({ graphql, name: 'login' });
                            setIsLoading(false);
                            window.location.href = `/account/dashboard`;
                        }
                    } else if (token.startsWith('AQI')) {
                        // window.location.href = '/bundles/login?email=' + enteredName;
                        setIsLoading(false);
                        const baseUrl = '/bundles/login?email=' + enteredName;
                        const isIonValue = loginOperation.data.login.isION;
                        const token = loginOperation.data?.login?.accessToken;

                        const contextVal = {
                            isIon: isIonValue,
                            token: token,
                            isNoticeClicked: false,
                        };

                        const context = encodeURIComponent(JSON.stringify(contextVal));
                        window.location.href = `${baseUrl}&context=${context}`;
                    }
                    sessionStorage.setItem('loginSuccess', true);
                }
            }
            setIsLoading(false);
            setWaitingApiResponse(false);
        }
    } catch (error) {
        setIsLoading(false);
        setWaitingApiResponse(false);
        console.error('error message after getbrand', error.message, openError);
        if (error.message.includes('Invalid reCAPTCHA!')) {
            setInvalidError(!invalidError);
            setCaptchaV2Error(!captchaV2Error);
            setInvalidText('Invalid reCAPTCHA!');
        } else if (error.message.includes('Request failed with status code 403')) {
            setInvalidError(!invalidError);
            setInvalidText('Your email or password may be incorrect');
        } else if (error.message.includes('Actions pending to complete registration')) {
            toggleRegister();
        } else if (
            error?.message?.includes('status code 500') ||
            error?.message?.includes('Internal server error') ||
            error?.response?.status === 500
        ) {
            console.log('internal error while login');
            // setOpenError(!openError);
            setTechnicalError(true);
        } else {
            setOpenError(!openError);
        }
        recaptchaRef?.current?.reset();
    }
};

export const submitForgotResetPassword = async ({
    setWaitingApiResponse,
    graphql,
    userName,
    toggle2,
    toggleError,
    recaptchaV3Token,
}) => {
    try {
        setWaitingApiResponse(true);
        const res = await resetPassword({
            graphql,
            emailAddress: userName,
            recaptcha: recaptchaV3Token,
            recaptchaVersion: 'V3',
        });
        setWaitingApiResponse(false);

        if (res.data.resetPassword) {
            toggle2();
        } else {
            console.error('something went wrong while triggering forgot/reset password');
            toggleError();
        }
    } catch (err) {
        setWaitingApiResponse(false);
        // setApiError(err.message);
        // toggleError();
        toggle2();
    }
};

export const setSessionStorageValues = async ({
    enteredName,
    loginOperation,
    token,
    featureList,
}) => {
    sessionStorage.setItem('LoggedinUser', enteredName);
    setCookie('ION', 'EMAIL_ADDRESS', enteredName);
    sessionStorage.setItem('LoggedinUserBrand', 'ion');
    sessionStorage.setItem('hasION', loginOperation.data.login.isION);
    sessionStorage.setItem('hasR6', loginOperation.data.login.isR6);
    sessionStorage.setItem('access_token', loginOperation.data.login.accessToken);
    sessionStorage.setItem('R6_status_code', loginOperation.data.login.statusCode);
    sessionStorage.setItem('R6_passwordResetToken', loginOperation.data.login.passwordResetToken);
    sessionStorage.setItem(
        'R6_numberOfAuthenticationAttemptsRemaining',
        loginOperation.data.login.numberOfAuthenticationAttemptsRemaining
    );
    sessionStorage.setItem('LoggedinUserFeatures', JSON.stringify(featureList?.features));

    /* Required data for redirection from my-eir to eir.ie*/

    const refreshToken = loginOperation.data.login.refreshToken;
    setCookie('ION', 'refresh_Token', refreshToken);
    sessionStorage.setItem('refresh_token', refreshToken);
    const refreshTokenExpiresIn = loginOperation.data.login.refreshTokenExpiresIn * 1000;
    const sessionExpiryTime = new Date(new Date().getTime() + refreshTokenExpiresIn).getTime();
    sessionStorage.setItem(
        'myEirSession',
        JSON.stringify({
            sessionExpiryTime,
            refreshTokenExpiresIn,
        })
    );
};

//Compare versions
export const isUpdateAvailable = ({ currentVersion, latestVersion, recentVersions }) => {
    try {
        if (!currentVersion || !latestVersion) return false;
        if (currentVersion === latestVersion) return false;
        const parse = version => version.split('.').map(Number);
        const isLessThan = (currentValue, latestValue) => {
            const currentVal = parse(currentValue);
            const latestVal = parse(latestValue);
            for (let i = 0; i < Math.max(currentVal.length, latestVal.length); i++) {
                if ((currentVal[i] || 0) < (latestVal[i] || 0)) return true;
                if ((currentVal[i] || 0) > (latestVal[i] || 0)) return false;
            }
            return false;
        };

        //check if current version or higher versions has update:true
        let updateRequired = false;
        for (const r of recentVersions) {
            if (isLessThan(currentVersion, r.version) || r.version === currentVersion) {
                if (r.update === true) {
                    updateRequired = true;
                    break;
                }
            }
        }
        return updateRequired;
    } catch (error) {
        console.error('Error in version comparison', error);
        return false;
    }
};
